<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Received Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div>
			<div style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">Carton</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.carton | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Qty</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.qty | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Amount</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.amount | toCurrency" />
					</label>
				</div>
			</div>
			<div class="fixed-table-container">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
						<colgroup>
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col style="width: 15%" />
							<col style="width: 5%" />
							<col style="width: 15%" />
							<col style="width: 7%" />
							<col style="width: 7%" />
							<col v-if="user.company_id == 'jc'" style="width: 4%" />
							<col style="width: 7%" />
							<col />
						</colgroup>

						<thead>
							<tr>
								<th>Received Date</th>
								<th>SH NO</th>
								<th>Vendor</th>
								<th>Vendor</th>
								<th>Delivery</th>
								<th>Delivery</th>
								<th>Carton</th>
								<th>Qty</th>
								<th v-if="user.company_id == 'jc'">U/M</th>
								<th>Amount</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="shipment in root.value.list" v-bind:key="shipment.sh_no">
								<td class="al_center">{{ shipment.received_date }}</td>
								<td class="al_center">
									<a href="javascript:void(0)" @click="shipmentGo(shipment.sh_no)">{{ shipment.sh_dn }} </a>
								</td>
								<td class="al_left">{{ shipment.vendor_code }}</td>
								<td class="al_left">{{ shipment.vendor_name }}</td>
								<td class="al_center">{{ shipment.delivery_place_code }}</td>
								<td class="al_left">{{ shipment.delivery_place_name }}</td>
								<td class="al_right">{{ shipment.carton | commaSeparated }}</td>
								<td class="al_right">{{ shipment.received_quantity | commaSeparated }}</td>
								<td v-if="user.company_id == 'jc'" class="al_center">{{ shipment.purchase_units }}</td>
								<td class="al_right">{{ shipment.received_amount | toCurrency }}</td>
								<td class="al_left truncate">{{ shipment.description }}</td>
							</tr>
							<tr>
								<td colspan="6"></td>
								<td class="al_right">{{ root.value.carton | commaSeparated }}</td>
								<td class="al_right">{{ root.value.qty | commaSeparated }}</td>
								<td v-if="user.company_id == 'jc'"></td>
								<td class="al_right">{{ root.value.amount | toCurrency }}</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
				<li v-if="user.company_id == 'jc'">
					<a href="javascript:void(0);" @click="sheet()">Sheet</a>
				</li>
			</ul>
		</div>

		<SheetCopyPopup v-if="sheet_popup" :sheet="sheet_popup" @close="sheet_popup = null" />
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import { objectToFormData, shipmentPageGo } from '@/api/util';
import { apiReceivedList } from '@/api/purchase/purchase';
import { exportExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import SheetCopyPopup from '@/components/common/SheetCopyPopup';

export default {
	data: function() {
		return {
			fromDate: daysAgo(6),
			toDate: today(),
			vendorCode: null,
			root: {
				value: {
					list: [],
				},
			},

			// #3312 초기 root.value.list 도 빈 배열이라 조회 성공 여부는 별도 플래그로 둔다.
			searched: false,
			sheet_popup: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		PartnerSelect,
		SheetCopyPopup,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			this.fromDate = this.user.company_id == 'he' ? daysAgo(365) : daysAgo(6);
			this.toDate = today();
			this.vendor_code = null;
		},
		async search() {
			const paramObj = {
				fromDate: this.fromDate,
				toDate: this.toDate,
				vendorCode: this.vendorCode,
			};
			const param = objectToFormData(paramObj);
			var { data } = await apiReceivedList(param);

			//console.log(data.value.list);
			//console.log(data);
			if (!this.user.po_price_view) {
				data.value.amount = null;
				data.value.list.forEach(l => {
					l.received_amount = null;
					l.vendor_code = null;
					l.vendor_name = null;
				});
			}

			this.root = data;
			this.searched = true; // #3312
		},
		excel() {
			const eid = 'excelTable';
			const fileName = 'ReceivedList_' + this.fromDate + '_' + this.toDate;
			exportExcel(eid, fileName);
		},
		// #3312 JC Sheet: 화면 11열과 같은 열 정의. po_price_view 가 없으면 search() 에서 null 로 마스킹된 값이 그대로 빈칸이 된다(열 위치 유지).
		sheetHeaders() {
			return [
				{ key: 'received_date', name: 'Received Date', dataType: defaultDataType.string },
				{ key: 'sh_dn', name: 'SH NO', dataType: defaultDataType.string },
				{ key: 'vendor_code', name: 'Vendor', dataType: defaultDataType.string },
				{ key: 'vendor_name', name: 'Vendor', dataType: defaultDataType.string },
				{ key: 'delivery_place_code', name: 'Delivery', dataType: defaultDataType.string },
				{ key: 'delivery_place_name', name: 'Delivery', dataType: defaultDataType.string },
				{ key: 'carton', name: 'Carton', dataType: defaultDataType.number },
				{ key: 'received_quantity', name: 'Qty', dataType: defaultDataType.number },
				{ key: 'purchase_units', name: 'U/M', dataType: defaultDataType.string },
				{ key: 'received_amount', name: 'Amount', dataType: defaultDataType.currency },
				{ key: 'description', name: 'Description', dataType: defaultDataType.string },
			];
		},
		// #3312 Sheet: 마지막 조회 결과 행 그대로, 헤더 아래 합계 행은 API 집계(carton·qty·amount)를 그대로 쓴다.
		sheet() {
			if (!this.searched || !this.root || !this.root.value || !Array.isArray(this.root.value.list)) {
				this.$toast.error('Please search first');
				return false;
			}
			this.sheet_popup = {
				title: 'Received List (Sheet)',
				headers: this.sheetHeaders(),
				rows: this.root.value.list,
				options: { total_row: { delivery_place_name: 'total', carton: this.root.value.carton, received_quantity: this.root.value.qty, received_amount: this.root.value.amount } },
			};
		},
		shipmentGo(shipmentNo) {
			shipmentPageGo(shipmentNo);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_receivedList');
		this.$store.commit('setSubTitle', 'Purchase -> Received List');

		if (this.user.company_id == 'he') this.fromDate = daysAgo(365);
	},
	mounted() {},
};
</script>

<style></style>
